<template>
  <div>
    <h3 class="my-15">Informations Personnelles</h3>
    <div
      v-if="!!newer?.data?.personnal?.old"
      class="text-pink-600 mb-10 text-center text-sm"
    >
      Certaines données ont été modifiées sur la page Informations Personnelles
      de votre Neopass, vous pouvez les mettres à jour en cliquant sur l'icone
      d'horloge situé à côté du champ correspondant.
    </div>

    <div class="grid grid-cols-2 gap-x-8 justify-center gap-y-5">
      <div class="col-span-full md:col-span-1 flex space-x-3 items-center">
        <radio-button
          class="pt-5"
          name="prenom_display"
          :value="
            ((((form || {}).data || {}).personnal || {}).prenom || {})
              .isDisplayed || false
          "
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).prenom || {}
              ).isDisplayed = newValue;
            }
          "
          @loseFocus="saveDatas()"
        />
        <input-text
          name="prenom"
          libelle="Prénom"
          :value="
            ((((form || {}).data || {}).personnal || {}).prenom || {}).value ||
            ''
          "
          placeholder="Prénom"
          :error="true"
          @input="
            (newValue) => {
              ((((form || {}).data || {}).personnal || {}).prenom || {}).value =
                newValue;
              (errors || []).prenom = [];
            }
          "
          @loseFocus="saveDatas()"
          :msg-error="((errors || []).prenom || [])[0]"
        />
        <CVNewValue
          class="pt-6"
          :old="newer?.data?.personnal?.prenom?.old"
          @change="
            (newValue) => {
              form.data.personnal.prenom.value = newValue;
              newer.data.personnal.prenom.old = false;
            }
          "
        />
      </div>

      <div class="col-span-full md:col-span-1 flex space-x-3 items-center">
        <radio-button
          class="pt-5"
          name="nom_display"
          :value="
            ((((form || {}).data || {}).personnal || {}).nom || {})
              .isDisplayed || false
          "
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).nom || {}
              ).isDisplayed = newValue;
            }
          "
          @loseFocus="saveDatas()"
        />
        <input-text
          name="nom"
          libelle="Nom"
          :value="((((form || {}).data || {}).personnal || {}).nom || {}).value"
          placeholder="Nom"
          :error="true"
          @input="
            (newValue) => {
              ((((form || {}).data || {}).personnal || {}).nom || {}).value =
                newValue;
              (errors || []).nom = [];
            }
          "
          @loseFocus="saveDatas()"
          :msg-error="((errors || []).nom || [])[0]"
        />
        <CVNewValue
          class="pt-6"
          :old="newer?.data?.personnal?.nom?.old"
          @change="
            (newValue) => {
              form.data.personnal.nom.value = newValue;
              newer.data.personnal.nom.old = false;
            }
          "
        />
      </div>

      <div class="col-span-full md:col-span-1 flex space-x-3 items-center">
        <radio-button
          class="pt-5"
          name="date_naissance_display"
          :value="
            ((((form || {}).data || {}).personnal || {}).date_naissance || {})
              .isDisplayed || false
          "
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).date_naissance || {}
              ).isDisplayed = newValue;
            }
          "
          @loseFocus="saveDatas()"
        />
        <date-picker
          name="date_naissance"
          libelle="Date de naissance"
          :value="
            ((((form || {}).data || {}).personnal || {}).date_naissance || {})
              .value
          "
          :error="true"
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).date_naissance || {}
              ).value = newValue;
              (errors || []).date_naissance = [];
            }
          "
          @loseFocus="saveDatas()"
          :msg-error="((errors || []).date_naissance || [])[0]"
        />
        <CVNewValue
          class="pt-6"
          :old="newer?.data?.personnal?.date_naissance?.old"
          @change="
            (newValue) => {
              form.data.personnal.date_naissance.value = newValue;
              newer.data.personnal.date_naissance.old = false;
            }
          "
        />
      </div>

      <div class="col-span-full md:col-span-1 flex space-x-3 items-center">
        <radio-button
          class="pt-5"
          name="telephone_display"
          :value="
            ((((form || {}).data || {}).personnal || {}).telephone || {})
              .isDisplayed || false
          "
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).telephone || {}
              ).isDisplayed = newValue;
            }
          "
          @loseFocus="saveDatas()"
        />
        <input-text
          name="telephone"
          libelle="Téléphone"
          :placeholder="'Téléphone'"
          :value="
            ((((form || {}).data || {}).personnal || {}).telephone || {}).value
          "
          :error="true"
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).telephone || {}
              ).value = newValue;
              (errors || []).telephone = [];
            }
          "
          @loseFocus="saveDatas()"
          :msg-error="((errors || []).telephone || [])[0]"
        />
        <CVNewValue
          class="pt-6"
          :old="newer?.data?.personnal?.telephone?.old"
          @change="
            (newValue) => {
              form.data.personnal.telephone.value = newValue;
              newer.data.personnal.telephone.old = false;
            }
          "
        />
      </div>

      <div class="col-span-full md:col-span-1 flex space-x-3 items-center">
        <radio-button
          class="pt-5"
          name="email_display"
          :value="
            ((((form || {}).data || {}).personnal || {}).email || {})
              .isDisplayed || false
          "
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).email || {}
              ).isDisplayed = newValue;
            }
          "
          @loseFocus="saveDatas()"
        />
        <input-text
          name="email"
          libelle="Email"
          :placeholder="'Email'"
          type="email"
          :value="
            ((((form || {}).data || {}).personnal || {}).email || {}).value
          "
          :error="true"
          @input="
            (newValue) => {
              ((((form || {}).data || {}).personnal || {}).email || {}).value =
                newValue;
              (errors || []).email = [];
            }
          "
          @loseFocus="saveDatas()"
          :msg-error="((errors || []).email || [])[0]"
        />
        <CVNewValue
          class="pt-6"
          :old="newer?.data?.personnal?.email?.old"
          @change="
            (newValue) => {
              form.data.personnal.email.value = newValue;
              newer.data.personnal.email.old = false;
            }
          "
        />
      </div>

      <div class="col-span-full flex space-x-3 items-center">
        <radio-button
          name="adresse_display"
          :value="
            ((((form || {}).data || {}).personnal || {}).adresse || {})
              .isDisplayed || false
          "
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).adresse || {}
              ).isDisplayed = newValue;
            }
          "
          @loseFocus="saveDatas()"
        />
        <input-text-area
          name="adresse"
          libelle="Adresse complète"
          :placeholder="'Adresse complète'"
          :value="
            ((((form || {}).data || {}).personnal || {}).adresse || {}).value
          "
          :error="true"
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).adresse || {}
              ).value = newValue;
              (errors || []).adresse = [];
            }
          "
          @loseFocus="saveDatas()"
          :msg-error="((errors || []).adresse || [])[0]"
        />
        <CVNewValue
          class="pt-6"
          :old="newer?.data?.personnal?.adresse?.old"
          @change="
            (newValue) => {
              form.data.personnal.adresse.value = newValue;
              newer.data.personnal.adresse.old = false;
            }
          "
        />
      </div>

      <div class="col-span-full flex space-x-3 items-center">
        <radio-button
          name="travailleur_handicape"
          :value="
            (
              (((form || {}).data || {}).personnal || {})
                .travailleur_handicape || {}
            ).value || false
          "
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {})
                  .travailleur_handicape || {}
              ).value = newValue;
            }
          "
          @loseFocus="saveDatas()"
        />
        <div class="text-base">
          Reconnaissance en tant que travailleur handicapé
        </div>
        <CVNewValue
          class="pt-6"
          :old="newer?.data?.personnal?.travailleur_handicape?.old"
          @change="
            (newValue) => {
              form.data.personnal.travailleur_handicape.value = newValue;
              newer.data.personnal.travailleur_handicape.old = false;
            }
          "
        />
      </div>

      <div class="col-span-full md:col-span-1 flex space-x-3 items-center">
        <radio-button
          class="pt-5"
          name="permis_conduire_display"
          :value="
            ((((form || {}).data || {}).personnal || {}).permis_conduire || {})
              .isDisplayed || false
          "
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).permis_conduire ||
                {}
              ).isDisplayed = newValue;
            }
          "
          @loseFocus="saveDatas()"
        />
        <multiple-select
          :datas="[
            { value: 'ASSR1' },
            { value: 'ASSR2' },
            { value: 'BSR' },
            { value: 'A' },
            { value: 'A1' },
            { value: 'B' },
            { value: 'B1' },
            { value: 'C' },
            { value: 'D' },
            { value: 'E' },
            { value: 'Autres' },
          ]"
          name="permis_conduire"
          libelle="Permis de conduire"
          :placeholder="'Permis de conduire'"
          :value="
            ((((form || {}).data || {}).personnal || {}).permis_conduire || {})
              .value
          "
          :error="true"
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).permis_conduire ||
                {}
              ).value = newValue;
              (errors || []).permis_conduire = [];
            }
          "
          @loseFocus="saveDatas()"
          :msg-error="((errors || []).permis_conduire || [])[0]"
        />
        <CVNewValue
          class="pt-6"
          :old="newer?.data?.personnal?.permis_conduire?.old"
          @change="
            (newValue) => {
              form.data.personnal.permis_conduire.value = newValue;
              newer.data.personnal.permis_conduire.old = false;
            }
          "
        />
      </div>

      <div class="col-span-full md:col-span-1 flex space-x-3 items-center">
        <radio-button
          class="pt-5"
          name="moyen_transport_display"
          :value="
            ((((form || {}).data || {}).personnal || {}).moyen_transport || {})
              .isDisplayed || false
          "
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).moyen_transport ||
                {}
              ).isDisplayed = newValue;
            }
          "
          @loseFocus="saveDatas()"
        />
        <multiple-select
          :datas="[
            { value: 'Aucun' },
            { value: 'Voiture' },
            { value: 'Moto' },
            { value: 'Scooter' },
            { value: 'Vélo' },
            { value: 'Marche' },
            { value: 'Train' },
            { value: 'Bus' },
            { value: 'Transports en commun' },
            { value: 'Autres' },
          ]"
          name="moyen_transport"
          libelle="Moyen de transport"
          :placeholder="'Moyen de transport'"
          :value="
            ((((form || {}).data || {}).personnal || {}).moyen_transport || {})
              .value
          "
          :error="true"
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).moyen_transport ||
                {}
              ).value = newValue;
              (errors || []).moyen_transport = [];
            }
          "
          @loseFocus="saveDatas()"
          :msg-error="((errors || []).moyen_transport || [])[0]"
        />
        <CVNewValue
          class="pt-6"
          :old="newer?.data?.personnal?.moyen_transport?.old"
          @change="
            (newValue) => {
              form.data.personnal.moyen_transport.value = newValue;
              newer.data.personnal.moyen_transport.old = false;
            }
          "
        />
      </div>

      <div class="col-span-full md:col-span-1 flex space-x-3 items-center">
        <radio-button
          class="pt-5"
          name="site_web_display"
          :value="
            ((((form || {}).data || {}).personnal || {}).site_web || {})
              .isDisplayed || false
          "
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).site_web || {}
              ).isDisplayed = newValue;
            }
          "
          @loseFocus="saveDatas()"
        />
        <input-text
          name="site_web"
          libelle="Site internet personnel"
          :placeholder="'Site internet personnel'"
          :value="
            ((((form || {}).data || {}).personnal || {}).site_web || {}).value
          "
          :error="true"
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).site_web || {}
              ).value = newValue;
              (errors || []).site_web = [];
            }
          "
          @loseFocus="saveDatas()"
          :msg-error="((errors || []).site_web || [])[0]"
        />
        <CVNewValue
          class="pt-6"
          :old="newer?.data?.personnal?.site_web?.old"
          @change="
            (newValue) => {
              form.data.personnal.site_web.value = newValue;
              newer.data.personnal.site_web.old = false;
            }
          "
        />
      </div>

      <div class="col-span-full md:col-span-1 flex space-x-3 items-center">
        <radio-button
          class="pt-5"
          name="linkedin_display"
          :value="
            ((((form || {}).data || {}).personnal || {}).linkedin || {})
              .isDisplayed || false
          "
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).linkedin || {}
              ).isDisplayed = newValue;
            }
          "
          @loseFocus="saveDatas()"
        />
        <input-text
          name="linkedin"
          libelle="Linkedin"
          :placeholder="'Linkedin'"
          :value="
            ((((form || {}).data || {}).personnal || {}).linkedin || {}).value
          "
          :error="true"
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).linkedin || {}
              ).value = newValue;
              (errors || []).linkedin = [];
            }
          "
          @loseFocus="saveDatas()"
          :msg-error="((errors || []).linkedin || [])[0]"
        />
        <CVNewValue
          class="pt-6"
          :old="newer?.data?.personnal?.linkedin?.old"
          @change="
            (newValue) => {
              form.data.personnal.linkedin.value = newValue;
              newer.data.personnal.linkedin.old = false;
            }
          "
        />
      </div>
      <div class="col-span-full md:col-span-1 flex space-x-3">
        <radio-button
          class="pt-5"
          name="profile_image_display"
          :value="
            ((((form || {}).data || {}).personnal || {}).profile_image || {})
              .isDisplayed || false
          "
          @input="
            (newValue) => {
              (
                (((form || {}).data || {}).personnal || {}).profile_image || {}
              ).isDisplayed = newValue;
            }
          "
          @loseFocus="saveDatas()"
        />
        <profile-picture
          id="photo"
          size="max-w-28 w-28 h-28"
          :is-circle-avatar="false"
          :specific-url="
            ((((form || {}).data || {}).personnal || {}).profile_image || {})
              .value || null
          "
          specific-rounded="rounded-xl"
          specific-media="cv-profile-picture"
          :show-edit-link="true"
          type-profile-picture="cv"
          :other-object="form"
          :with-border="true"
          @changeProfileImageToAnotherUser="
            (newUrl) => {
              (
                (((form || {}).data || {}).personnal || {}).profile_image || {}
              ).value = newUrl;
            }
          "
        />
        <!-- <CVNewValue
                    class="pt-6"
                    :old="newer?.data?.personnal?.profile_image?.old"
                    @change="(newValue) => {form.data.personnal.profile_image.value = newValue; newer.data.personnal.profile_image.old = false}"
                /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import RadioButton from './../../../components/Inputs/RadioButton.vue';
import InputText from './../../../components/Inputs/InputText.vue';
import InputTextArea from './../../../components/Inputs/InputTextArea.vue';
import DatePicker from './../../../components/Inputs/DatePicker.vue';
import MultipleSelect from './../../../components/Inputs/MultipleSelect.vue';

import ProfilePicture from './../../../components/ProfilePicture.vue';
import CVNewValue from './CVNewValue';

export default {
  name: 'InformationsPersonnelles',

  components: {
    CVNewValue,
    InputText,
    InputTextArea,
    RadioButton,
    DatePicker,
    MultipleSelect,
    ProfilePicture,
  },

  methods: {
    ...mapMutations({
      SET_FORM: 'curriculumVitae/SET_FORM',
    }),
    ...mapActions({
      saveDatas: 'curriculumVitae/saveDatas',
    }),
  },

  computed: {
    ...mapGetters({
      form: 'curriculumVitae/form',
      newer: 'curriculumVitae/newForm',
      errors: 'curriculumVitae/errors',
    }),
  },
};
</script>
